import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { trackEvent } from '../lib/analytics';

const HIDDEN_PATHS = ['/quote', '/viewQuote', '/view-quote', '/viewQuote1', '/seed'];
const SCROLL_THRESHOLD_PERCENT = 25;

/**
 * Persistent mobile-only CTA bar driving users into the quote funnel.
 * Fixed position, so it never causes layout shift.
 * Only appears after the user has scrolled more than 25% down the page.
 */
export function StickyQuoteCTA() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(false);

    const handleScroll = () => {
      const scrolled = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      const pct = (scrolled / docHeight) * 100;
      setVisible(pct >= SCROLL_THRESHOLD_PERCENT);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pathname]);

  if (HIDDEN_PATHS.includes(pathname)) {
    return null;
  }

  const handleClick = () => {
    trackEvent('quote_cta_click', {
      event_category: 'engagement',
      event_label: 'sticky_mobile_bar',
    });
  };

  return (
    <div className={`md:hidden fixed bottom-0 inset-x-0 z-50 p-3 bg-brand-primary/95 backdrop-blur border-t border-brand-alternate pb-[calc(0.75rem+env(safe-area-inset-bottom))] transition-transform duration-300 ${visible ? 'translate-y-0' : 'translate-y-full'}`}>
      <Link
        to="/quote"
        onClick={handleClick}
        className="w-full h-12 inline-flex items-center justify-center gap-2 bg-brand-tertiary text-brand-primary text-base font-bold rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-white"
      >
        Get an instant quote — takes 60 seconds
        <ArrowRight className="w-5 h-5" aria-hidden="true" />
      </Link>
    </div>
  );
}
